/**
 * 契約中プラン一覧、購入履歴の表示を管理するStateを扱うモジュール
 */
import { ActionsUnion, createAction } from 'common/utils/action-utils';

export enum ActionTypes {
  SET_STATUS = 'app/purchase/SET_STATUS',
  IS_DELETED_PLAN = 'app/purchase/IS_DELETED_PLAN',
  IS_CANCELLATION_CONFIRMATION = 'app/purchase/IS_CANCELLATION_CONFIRMATION'
}

/**
 * 画面の表示状態を設定するのActionを作成する
 * @param {PurchaseStatus} payload 表示画面
 */
export const setStatus = (payload: PurchaseStatus) =>
  createAction(ActionTypes.SET_STATUS, payload);

/**
 * 解約実施済みか否かを設定するActionを作成する
 * @param {boolean} isDeletedPlan 解約実施済みか否か
 */
export const isDeletedPlan = (isDeletedPlan: boolean) =>
  createAction(ActionTypes.IS_DELETED_PLAN, isDeletedPlan);

/**
 * 利用解除済みか否かを設定するActionを作成する
 * @param {boolean} isFlag 利用解除済みか否か
 */
export const isCancellationConfirmation = (isFlag: boolean) =>
  createAction(ActionTypes.IS_CANCELLATION_CONFIRMATION, isFlag);

const actions = {
  setStatus,
  isDeletedPlan,
  isCancellationConfirmation
};
type PurchaseAction = ActionsUnion<typeof actions>;

export enum PurchaseStatus {
  /** 契約中のプラン一覧の表示 */
  CONTRACT_DISP = 'contract',
  /** 購入履歴の表示 */
  HISTORY_DISP = 'history'
}

/**
 * 画面表示有無のState
 */
export interface PurchaseState {
  /** 表示状態 */
  status: PurchaseStatus;
  /** 解約状態 */
  isDeletedPlan: boolean;
  /** 利用解除状態 */
  isCancellationConfirmation: boolean;
}

const initialState: PurchaseState = {
  status: PurchaseStatus.CONTRACT_DISP,
  isDeletedPlan: false,
  isCancellationConfirmation: false
};

export default (
  state: PurchaseState = initialState,
  action: PurchaseAction
): PurchaseState => {
  switch (action.type) {
    case ActionTypes.SET_STATUS:
      return { ...state, status: action.payload };
    case ActionTypes.IS_DELETED_PLAN:
      return { ...state, isDeletedPlan: action.payload };
    case ActionTypes.IS_CANCELLATION_CONFIRMATION:
      return { ...state, isCancellationConfirmation: action.payload };
    default:
      return state;
  }
};
